import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';

// import { AgGridAngular } from 'ag-grid-angular';
ModuleRegistry.registerModules([AllCommunityModule]);



@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterModule,
    // AgGridAngular
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {
  title = 'Angular Ecommerce Dashboard | TailAdmin';
}
